// src/app.js
import './js/stocks-toggle.js';

jQuery(document).ready(function ($) {
  $('html').removeClass('no-js');
});

